module.exports = __webpack_public_path__ + "img/cc-logos.ed2def90.png";